import { Link } from "@inertiajs/inertia-react";
import React from "react";
import PropTypes from "prop-types";
import { IconEmptyBox } from "@/Icons";

const EmptyState = ({
  title,
  text,
  buttonText,
  buttonRoute = null,
  buttonOnClick = null,
}) => {
  return (
    <div className="mt-10 flex w-full flex-col items-center justify-center gap-1 p-4 text-center">
      <IconEmptyBox size={40} className="mb-4 text-typo-inactive" />
      <p className="font-bold">{title}</p>
      <p className="mb-4 text-typo-inactive">{text}</p>
      {buttonRoute && buttonText && (
        <Link href={buttonRoute} className="btn-blue">
          {buttonText}
        </Link>
      )}
      {buttonOnClick && buttonText && (
        <button onClick={buttonOnClick} className="btn-blue">
          {buttonText}
        </button>
      )}
    </div>
  );
};

EmptyState.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  buttonRoute: PropTypes.string,
  buttonText: PropTypes.string,
  buttonOnClick: PropTypes.func,
};

export default EmptyState;
